import React from 'react';

import LoginForm from '@components/LoginForm';

import styles from './style.module.scss';

const Login: React.FC = () => {
  return (
    <div className={styles.container}>
      <main>
        <LoginForm />
      </main>
    </div>
  );
};

export default Login;
